/**
 * Canonical leave-type display categories — the `portal_leave_types.badge_type`
 * vocabulary.
 *
 * Single source of truth shared by the seed (`seed.ts`), the Humaans migration
 * (`mapLeaveBadgeType`), and the client badge UIs (`PortalAbsenceBadge` + the
 * calendar leave bars). Every value here MUST have a matching CSS class in
 * `portal-absence-badge.css` and `calendar-view.css` — `leave-badge-types.test.ts`
 * enforces that, so the vocabularies can't silently drift apart again.
 */
export const LEAVE_BADGE_TYPES = [
    'vacation',
    'sick',
    'child',
    'paternity',
    'maternity',
    'unpaid',
    'study',
    'training',
    'development',
    'health',
    'personal',
    'bereavement',
    'care',
    'military',
    'weekoff',
    'client_event',
    'internal_event',
    'remote',
    'other',
] as const

export type LeaveBadgeType = (typeof LEAVE_BADGE_TYPES)[number]

/**
 * Leave-type categories — the two groups the portal shows in the booking
 * dropdown and balance table. "working" = work-related activities tracked as
 * absence-from-desk (development day, client/internal events); "time_off" =
 * actual leave (vacation, sick, parental, …). Stored on
 * `portal_leave_types.category`.
 */
export const LEAVE_CATEGORIES = ['working', 'time_off'] as const

export type LeaveCategory = (typeof LEAVE_CATEGORIES)[number]

export const isLeaveCategory = (value: unknown): value is LeaveCategory =>
    typeof value === 'string' && (LEAVE_CATEGORIES as readonly string[]).includes(value)
